import { createContext, useCallback, useContext, useEffect, useState } from "react";
import adminApi from "../lib/adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const r = await adminApi.get("/admin/me");
      setAdmin(r.data);
    } catch {
      localStorage.removeItem("admin_token");
      setAdmin(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = useCallback(async (email, password) => {
    const r = await adminApi.post("/admin/login", { email, password });
    localStorage.setItem("admin_token", r.data.token);
    setAdmin(r.data.admin);
    return r.data.admin;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("admin_token");
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, setAdmin, loading, login, logout, refresh: checkAuth }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
  return ctx;
};
